import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RequestHelper from "../../../helpers/RequestHelper";
import { getGenelDurumString } from "../../../features/loadingMessageSlice";
import { getCurrentUser } from "../../../features/currentUserSlice";
import GenelDurumHelper, { GenelDurumLoginStateHelper } from "../../../helpers/GenelDurumHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import { IMainScreenProps, MainLayout } from "../../../components/layout/MainLayout";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import Columns from "../../../library/components/layout/Columns";
import CsmTextField from "../../../library/components/mui/common/CsmTextField";
import { mainScreenLocations } from "../../../app/mainScreens";
import Cell from "../../../library/components/layout/Cell";
import JsonHelper from "../../../library/helpers/JsonHelper";
import Rows from "../../../library/components/layout/Rows";
import appColors from "../../../app/appColors";
import { OtpAraRequestModel } from "../../../models/requestModels/OtpAraRequestModel";
import { OtpViewModel } from "../../../models/viewModels/OtpViewModel";
import CsmNumericField from "../../../library/components/mui/common/CsmNumericField";
import AlertHelper from "../../../library/helpers/AlertHelper";
import { useTranslation } from "react-i18next";
import TranslationHelper from "../../../helpers/TranslationHelper";
import DateTimeToStringHelper from "../../../library/helpers/DateTimeToStringHelper";

function OtpYonetimScreen() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const translate = TranslationHelper.TransFunc(t);
  const requestHelper = RequestHelper(navigate, dispatch, translate);

  const genelDurum = GenelDurumHelper.StringToModel(useAppSelector(getGenelDurumString)!)!;
  const user = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (!user.token || genelDurum == null) {
      GenelDurumLoginStateHelper.GenelDurumYukleVeKoroAyarla(requestHelper, navigate, dispatch, user, genelDurum);
    }
  })

  if (!user.token || genelDurum == null) {
    return <></>;
  }

  const genelDurumHelper = new GenelDurumHelper(genelDurum, user, translate, navigate, dispatch, i18n, requestHelper);

  return <OtpYonetimScreenInner genelDurumHelper={genelDurumHelper} />
}

function OtpYonetimScreenInner(props: IMainScreenProps) {
  const { genelDurumHelper } = props;

  const [model, setModel] = useState<OtpAraRequestModel>(new OtpAraRequestModel(null, ""));
  const [otpler, setOtpler] = useState<OtpViewModel[]>([]);

  const updateRequestModel = (action: (model: OtpAraRequestModel) => void) => {
    const result = JsonHelper.deepCopy(model);
    action(result);
    setModel(result);
  }

  function linkOlustur(otp: OtpViewModel): string {
    return `${window.location.origin}/yenisifre/${otp.otp}`;
  }

  function kopyala(otp: OtpViewModel): void {
    const link = linkOlustur(otp);
    navigator.clipboard.writeText(link);
  }

  const otpTableGetir = (otpList: OtpViewModel[]): JSX.Element => {
    return (
      <TableContainer>
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Tarih</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Kullanıcı</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Ad Soyad</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Korolar</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Kullanıldı Mı</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {otpList.map((otp) => (
              <TableRow
                key={otp.otp}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:nth-of-type(odd)': { backgroundColor: appColors.ACTION_HOVER },
                }}>
                <TableCell component="th" scope="row">{DateTimeToStringHelper.toDatetimeWithSecondsString(otp.olusturmaTarih)}</TableCell>
                <TableCell align="right">{otp.kullaniciAdi}</TableCell>
                <TableCell align="right">{otp.adSoyad}</TableCell>
                <TableCell align="right">{otp.koroIsimler.join(", ")}</TableCell>
                <TableCell align="right">{(otp.kullanildiMi ?? false) ? "Evet" : "Hayır"}</TableCell>
                <TableCell align="right">
                  <Button onClick={() => kopyala(otp)}>
                    {appIcons.Genel.ileri}
                    Kopyala
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  const search = async () => {
    const webResponse = await genelDurumHelper.requestHelper.Genel.OtpGetir(model);
    if (!webResponse.successfull)
      return;

    setOtpler(webResponse.data?.orderByDesc(e => e.olusturmaTarih) ?? []);
  }

  const otpTemizle = async (days: number) => {
    const webResponse = await genelDurumHelper.requestHelper.Genel.OtpTemizle(days);
    if (!webResponse.successfull)
      return;

    await search();

    AlertHelper.ShowMessage("Dikkat", "Otpler temizlendi");
  }

  return (
    <MainLayout
      location={mainScreenLocations.otpYonetim}
      genelDurumHelper={genelDurumHelper}
      hideHeader={false}
      hideMenu={false}>
      <Rows>
        <CsmText header style={{ marginBottom: "10px" }}>Kriterler</CsmText>
        <Columns mb={10}>
          <Cell width={200} style={{ margin: "5px" }}>
            <CsmTextField value={model.kullaniciAdiIceren} onChange={(e) => updateRequestModel(t => t.kullaniciAdiIceren = e)} label="E-Posta Adresi" />
          </Cell>
          <Cell width={200} style={{ margin: "5px" }}>
            <CsmNumericField value={model.sonDakika} onChange={(e) => updateRequestModel(t => t.sonDakika = e)} label="Son dakika" />
          </Cell>
          <Cell ml={10} mt={10}>
            <Button variant="contained" onClick={() => search()}>
              {appIcons.Genel.search}
              <Typography>Ara</Typography>
            </Button>
          </Cell>
          <Cell ml={10} mt={10}>
            <Button variant="contained" onClick={() => otpTemizle(10)}>
              {appIcons.Genel.backspace}
              <Typography>10 Günden Öncekileri Temizle</Typography>
            </Button>
          </Cell>
        </Columns>
        <CsmText style={{ marginBottom: "10px" }} header>Sonuçlar</CsmText>
        {otpTableGetir(otpler)}
      </Rows>
    </MainLayout>
  );
}

export default OtpYonetimScreen;

